import { createFileRoute } from '@tanstack/react-router'
import { CatalogBrowser } from '@/features/parts/catalog-browser'
import { requireFlow } from '@/features/auth/guards'

export const Route = createFileRoute('/_authenticated/service/parts')({
  beforeLoad: requireFlow('service'),
  component: PartsCatalogPage,
})

function PartsCatalogPage() {
  return <CatalogBrowser />
}
